/* rt-quick-add — a janela de quick-add do Broadcast (o «Ajouter»/«Add» do carrinho) com as peças
   da PDP. O conteúdo chega por AJAX (sections/api-product-upsell.liquid) e o tema mete-o com
   innerHTML, onde um <script> inline não corre — por isso é aqui que se liga:
     - a galeria mobile (window.rtGalleryNav, assets/rt-gallery-nav.js), igual à da PDP, e
       também no desktop, onde a janela é um painel da largura de um telemóvel;
     - a fila de avis da PDP (assets/rt-revacc-swipe.js), com as da coleção do produto;
     - o guia de tamanhos (snippets/rt-size-guide.liquid) ao lado do rótulo do tamanho, como o
       rt-product-options-enhance faz na PDP. Move-se o <popup-component> INTEIRO: o botão tem de
       continuar filho dele (o componente liga os eventos no construtor);
     - o que o rt-product-options-enhance faz na PDP e a janela não tinha: saltar para um tamanho
       que existe quando a cor escolhida não tem o atual, ordenar tamanhos numéricos, e fechar a
       etiqueta da cor ao tocar (o tooltip do Broadcast só fecha no mouseleave).
   Gatilho: o evento do tema `theme:quick-add:open`, que dispara depois de o conteúdo entrar e
   também quando a janela (guardada por produto) se reabre. Tudo o que se liga é idempotente. */
(function () {
  if (window.rtQuickAdd) return;
  window.rtQuickAdd = true;

  var SIZE_LEGEND = '.selector-wrapper--size .radio__legend, .selector-wrapper--rt-dropdown .radio__legend';

  function placeSizeGuide(modal) {
    var guia = modal.querySelector('[data-rt-size-guide]');
    var btn = guia && guia.querySelector('[data-rt-size-finder]');
    // mais de 10 tamanhos (anéis, calçado) = dropdown, com outra classe no wrapper
    var legend = modal.querySelector(SIZE_LEGEND);
    if (!btn || !legend || !btn.classList.contains('rt-pdp-size-finder--pending')) return;
    legend.classList.add('radio__legend--with-action');
    legend.appendChild(guia);
    btn.classList.remove('rt-pdp-size-finder--pending');

    var sgDialog = guia.querySelector('dialog');
    if (!sgDialog) return;
    // O guia é um <dialog> DENTRO do <dialog> da janela, e os dois fecham com «clique cujo alvo é
    // um DIALOG» e com Escape. O guia trata o dele e o evento subia até à janela, que fechava
    // também. Pára aqui, depois dos handlers do próprio guia (que correm primeiro no mesmo nó).
    ['click', 'keydown'].forEach(function (type) {
      sgDialog.addEventListener(type, function (e) { e.stopPropagation(); });
    });
    // Ao abrir, o guia prende o foco nele; ao fechar tira-o e a janela ficava sem foco preso.
    sgDialog.addEventListener('theme:popup:onclose', function () {
      if (modal.hasAttribute('open') && window.theme && window.theme.a11y) window.theme.a11y.trapFocus(modal);
    });
  }

  // Tamanhos numéricos pela ordem crescente (os fornecedores criam as variantes por cor, e a
  // escada grande vem primeiro). Só a ordem visual: a variante inicial não muda.
  function orderNumericSizes(modal) {
    var inputs = modal.querySelectorAll('.selector-wrapper--size .radio__button input[type="radio"]');
    var nums = [];
    for (var i = 0; i < inputs.length; i++) {
      var m = /^(\d+)(?:-\d+)?$/.exec(inputs[i].value.trim());
      if (!m) return; // tamanhos em letras ficam como estão
      nums.push([inputs[i], parseInt(m[1], 10)]);
    }
    nums.forEach(function (pair) {
      var b = pair[0].closest('.radio__button');
      if (b) b.style.order = pair[1];
    });
  }

  function bindOptions(modal) {
    // Cor sem o tamanho atual: o SelloutVariants do tema marca-o .unavailable e o rt-product.css
    // esconde-o, ficando «Indisponible» sem preço e sem tamanho à vista. Salta para o 1.º que existe,
    // como a PDP. O rAF deixa o tema recalcular as classes primeiro.
    modal.addEventListener('change', function () {
      requestAnimationFrame(function () {
        if (!modal.querySelector('.selector-wrapper--size input[type="radio"]:checked.unavailable')) return;
        var ok = modal.querySelector('.selector-wrapper--size input[type="radio"]:not(.unavailable)');
        if (ok) ok.click();
      });
    });
    modal.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('tooltip-component')) return;
      document.dispatchEvent(new CustomEvent('theme:tooltip:close', { detail: { hideTransition: false } }));
    });
  }

  // O card do carrinho estava a mostrar o produto numa cor que liga ao carrinho
  // (window.rtQuickAddColour, posto pelo assets/rt-cart-recs.js no clique): a janela abre nessa cor.
  function preselectColour(modal) {
    var wanted = window.rtQuickAddColour;
    window.rtQuickAddColour = null;
    if (!wanted) return;
    var input = Array.prototype.find.call(modal.querySelectorAll('.radio__fieldset--swatches input[type="radio"]'), function (i) {
      return i.value.toLowerCase() === wanted;
    });
    if (input && !input.checked) {
      var label = modal.querySelector('label[for="' + input.id + '"]');
      if (label) label.click();
    }
  }

  function enhance(modal) {
    if (!modal.dataset.rtQuickAdd) {
      modal.dataset.rtQuickAdd = '1';
      bindOptions(modal);
    }
    preselectColour(modal);
    var images = modal.querySelector('product-images.product-quick-add__images');
    if (images && window.rtGalleryNav) window.rtGalleryNav(images, images.querySelector('.rt-pdp-counter'), { always: true });
    placeSizeGuide(modal);
    orderNumericSizes(modal);
    // a fila de avis (snippets/rt-reviews-accordion.liquid): swipe como na PDP
    if (window.rtRevaccSwipe) modal.querySelectorAll('.rt-revacc[data-resume]').forEach(window.rtRevaccSwipe);
  }

  document.addEventListener('theme:quick-add:open', function () {
    document.querySelectorAll('.product-quick-add[open]').forEach(enhance);
  });
})();
